/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Section_Next_Due_DateInputs */

const fr_membership_section_next_due_date = /** @type {(inputs: Membership_Section_Next_Due_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prochaine échéance`)
};

/**

* @param {Membership_Section_Next_Due_DateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_section_next_due_date = /** @type {((inputs?: Membership_Section_Next_Due_DateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Section_Next_Due_DateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_section_next_due_date(inputs)
});